import { createRoot } from "react-dom/client";
// mapbox-gl itself is loaded on demand, with its worker and supported() setup: see
// loadMapboxgl in config/mapbox.ts. Only its stylesheet is global.
import "mapbox-gl/dist/mapbox-gl.css";

import App from "./App";

const root = createRoot(document.getElementById("root") as any);
root.render(<App />);
